import { IsBoolean, IsDecimal, IsNumberString } from 'class-validator';

export class GiftCardTopupResponse {
  constructor(
    cardNumber: string,
    balance: number,
    previousBalance: number,
    topupAmount: number,
    success: boolean,
    reference: number
  ) {
    this.cardNumber = cardNumber;
    this.balance = balance;
    this.previousBalance = previousBalance;
    this.topupAmount = topupAmount;
    this.success = success;
    this.reference = reference;
  }

  cardNumber: string;

  @IsDecimal()
  balance: number;

  @IsDecimal()
  previousBalance: number;

  @IsDecimal()
  topupAmount: number;

  @IsBoolean()
  success: boolean;

  @IsDecimal()
  reference: number;
}
